var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTurbineOnMist = function SvgTurbineOnMist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F7",
    d: "M28.18 49.583 25.94 22.83h-1.174L23.69 49.583s1.323.43 4.491 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M25.56 20.261s14.818 11.19 16.983 10.79c2.165-.4-11.509-10.964-11.509-10.964s-4.092-.67-5.473.174Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m39.105 26.571-1.568 1.846c1.033.69 2.1 1.324 3.197 1.896l.92-1.218c-.64-.72-1.54-1.597-2.55-2.524Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M24.792 20.583S8.796 30.093 8.355 32.222c-.44 2.127 14.444-6.515 14.444-6.515s2.246-3.517 1.993-5.124Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m13.585 30.678-1.075-2.236a36.956 36.956 0 0 0-3.041 2.386l.755 1.357c.926-.358 2.094-.893 3.361-1.507Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M25.414 20.209s1.748-18.446.358-20.097c-1.39-1.651-3.206 15.482-3.206 15.482s1.473 3.865 2.848 4.615Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m24.064 5.191 2.234.422a34.03 34.03 0 0 0-.092-3.557l-1.415-.185a48.855 48.855 0 0 0-.727 3.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M25.998 17.965H24.94a1.44 1.44 0 0 0-1.055.397 1.498 1.498 0 0 0-.47 1.044v.77l-.099 3.401 4.002-.367.113-2.882v-.771a1.548 1.548 0 0 0-.39-1.102 1.491 1.491 0 0 0-1.043-.49Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.187 21.706a1.123 1.123 0 1 0 0-2.246 1.123 1.123 0 0 0 0 2.246Z"
  })));
};
export default SvgTurbineOnMist;